import {  Container, Grid } from '@material-ui/core'
import React, { useState } from 'react'
import {useSelector } from 'react-redux'
import { useFirestoreConnect, isLoaded } from 'react-redux-firebase'
import groupBy from 'lodash.groupby'
import Loading from '../../shared/components/Loading'
import ReceivedGroup from './../Layout/ReceivedGroup';
import { RECEIVED_TYPES } from './../../shared/constants/receivedType';

const InReceiving = () => {
    const [expanded, setExpanded] = React.useState(false);
    const [receivedGroup, setReceivedGroup] = React.useState([])
    const [isLoading, setLoading] = useState(false)

    useFirestoreConnect(()=>[
        {collection : 'received_orders', orderBy:[['UpdateAt', 'desc']], where:[['ActivityStatus', '==', 'Open']], storeAs: 'receivedOrders'}
    ])


    const receivedOrders = useSelector(state => state.firestore.ordered['receivedOrders'])

    React.useEffect(()=>{

        if(!isLoaded(receivedOrders)){
            setLoading(true)
        }else{
            setLoading(false)
        }

        const rGroup =  receivedOrders && receivedOrders?.length > 0 && groupBy(receivedOrders, 'ShippingId')
        setReceivedGroup(rGroup)
    },[receivedOrders])


    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };


    return (
        <>
       {isLoading && <Container style={{position:'absolute' , display: 'flex',left:'50%', top:0, width:300, height:300}}>
            <Loading top={200} />
        </Container>
        }
        <Grid container spacing={1}>
           {
               (typeof(receivedGroup) !== 'undefined' &&  receivedGroup !== null ) &&
            
               Object.entries(receivedGroup).map(([key, value], idx)=>{
                return (<ReceivedGroup key={idx} 
                                ShippingId={key}  
                                Receiving={value} 
                                expanded={expanded} 
                                handleChange={handleChange}
                                receivingType={RECEIVED_TYPES.IN_RECEIVING}
                            /> );
               })

           }
        </Grid>
        </>
    )
}

export default InReceiving








